// ShellTooltipRoot — the tooltip layer's panel skin: the brand's floating
// chrome, the same recipe as the brand QuestionMarkTooltip panel — the branded
// `card` fill (opaque, one fill step above the pane sheet) with `title` ink,
// the one `overlay` elevation, `radiusControl`, the absolute `tooltipText`
// size (the Z step in rem, so it never compounds with the trigger's font), em
// padding, weight 500 (a label), one line at most. `card .background` takes
// only the card's FILL, so the `title` ink has no theme colour to race on
// emission order. The plugin's own default ('tooltip .quaternary' until smbls
// cab7004d9) named a theme no design system defines: the panel painted no
// surface at all and its label ran straight over the controls under it
// (measured live 2026-09-24). One definition for every root that hosts
// tooltips: the workspace shell (app.js `TooltipRoot`) and the comm app
// (comm/app.js); each root keeps its own mount props (zIndex, its stage).
export const ShellTooltipRoot = {
  extends: 'TooltipRoot',
  Panel: {
    theme: 'card .background',
    color: 'title',
    shadow: 'overlay',
    round: 'radiusControl',
    fontSize: 'tooltipText',
    fontWeight: '500',
    lineHeight: '1.45',
    padding: 'Y Z1',
    maxWidth: 'G1',
    // Credit details are a short breakdown, not a one-line control label.
    whiteSpace: (el) => (el.tip?.id === 'build-credit-balance' ? 'pre-line' : 'nowrap'),
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
}
